export default {"src":"/_next/static/media/secure-password.42a919f4.svg","height":116,"width":366,"blurWidth":0,"blurHeight":0};